import React, { Fragment, Component } from 'react'
import { Container, Row, Col, Carousel, Jumbotron, Button } from 'react-bootstrap'
import ProductCard from './ProductCard'
import Helmet from "react-helmet"
import Axios from '../../services/services'
import FormsInput from '../Ui/FormsInput'
import Buttons from '../Ui/buttons/Buttons'
import * as actions from '../../store/actions/index'

import { connect } from 'react-redux'

const forms =  {
    prices: {
        title: 'Prices',
        elementType: 'slider',
        variant: 'outlined',
        label: 'Prices',
        name: 'five',
        value: [],
        min: 0,
        max: 0,
        elementConfig: {
            options: []
        }
    },
    product_delivery_period: {
        elementType: 'select',
        variant: 'outlined',
        label: 'Delivery Period',
        name: 'product_delivery_period',
        elementConfig: {
            required: true,
            options: [
                { value: '1', displayValue: 'Within 5 days' },
                { value: '2', displayValue: 'Within 10 days' },
                { value: '3', displayValue: 'Within 20 days' },
                { value: '4', displayValue: 'More than 20 days' }
            ]
        },
        value: '',
        classname: 'col-md-12',
        validation: {
            type: 'text',
            required: true,
            minLength: 1,
            maxLength: 30,
        },
        invalid: false,
    },
    brand: {
        elementType: 'checkboxGroup',
        variant: 'outlined',
        label: 'Brand',
        name: 'brand',
        elementConfig: {
            required: true,
            options: []
        },
        classname: '',
    }
}
class Products extends Component {

    state = {
        valueTxt: 30,
        searchValue: "",
        search: {
            elementType: 'input',
            variant: 'outlined',
            label: 'Search',
            elementConfig: {
                maxLength: 100,
            },
            type: "text",
            name: 'code',
            value: '',
            validation: {
                type: 'text',
                required: true,
            },
            classname: '',
            color: '#212529',
        },
        MainCategory: '',
        SubCategory: '',
        filterForm: {
            prices: {
                title: 'Prices',
                elementType: 'slider',
                variant: 'outlined',
                label: 'Prices',
                name: 'five',
                value: [],
                min: 0,
                max: 0,
                elementConfig: {
                    options: []
                }
            },
            product_delivery_period: {
                elementType: 'select',
                variant: 'outlined',
                label: 'Delivery Period',
                name: 'product_delivery_period',
                elementConfig: {
                    required: true,
                    options: [
                        { value: '1', displayValue: 'Within 5 days' },
                        { value: '2', displayValue: 'Within 10 days' },
                        { value: '3', displayValue: 'Within 20 days' },
                        { value: '4', displayValue: 'More than 20 days' }
                    ]
                },
                value: '',
                classname: 'col-md-12',
                validation: {
                    type: 'text',
                    required: true,
                    minLength: 1,
                    maxLength: 30,
                },
                invalid: false,
            },
            brand: {
                elementType: 'checkboxGroup',
                variant: 'outlined',
                label: 'Brand',
                name: 'brand',
                elementConfig: {
                    required: true,
                    options: []
                },
                classname: '',
            }
        },
        loading: true,
        data: [],
        fixedLeft: false
    }

    constructor(props) {
        super(props)

    }

    componentDidMount() {
        // window.addEventListener('scroll', this.handleScroll, true)
        let subCategory = this.props.match.params.subCategory
        let Maincategory = this.props.match.params.category

        const formData = new FormData()
        formData.append(`main_category_slug`, Maincategory)
        formData.append(`sub_category_slug`, subCategory)
        this.getProductAPI(formData, 'didmonunt')
        this.setState({
            Maincategory: Maincategory,
            SubCategory: subCategory
        })
        // this.props.onFetchProducts(formData)
       

    }
    componentDidUpdate(prevProps, prevState, snapshot){
        
        if(prevProps.match.params.subCategory!==this.props.match.params.subCategory || prevProps.match.params.category !== this.props.match.params.category){
            const formData = new FormData()
            let subCategory = this.props.match.params.subCategory
            let Maincategory = this.props.match.params.category
            this.setState({data:[]})
            formData.append(`main_category_slug`, Maincategory)
            formData.append(`sub_category_slug`, subCategory)
            this.getProductAPI(formData, 'didmonunt')
            this.setState({
                Maincategory: Maincategory,
                SubCategory: subCategory
            })
        }
    }

    componentWillUnmount() {
        // window.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll = () => {
        var root = document.getElementById('root')
        var banner = document.querySelector(".banner")
        const offset = root.scrollTop
        const inner = banner.offsetHeight - 20
        if (inner <= offset) {
            this.setState({ fixedLeft: true })
        }
        else {
            this.setState({ fixedLeft: false })
        }
    }

    getProductAPI = (formData, params) => {
        const EditfilterForm = { ...this.state.filterForm }
        this.setState({loading:true})
        Axios.productServices.getProduct(formData)
            .then(response => {
                var tempBrand = []
                var marks = []
                var min, max
                const data = response.data.data[1].products
                if (params == "didmonunt") {
                    response.data.data[0].aggregation.brand.map((d, i) => {
                        tempBrand.push({ id: d.id, name: d.company_name, value: false, retailer_public_id: d.retailer_public_id })
                    })
                    EditfilterForm.prices.value=[]
                    EditfilterForm.brand.elementConfig.options = tempBrand
                    EditfilterForm.prices.max = parseInt(response.data.data[0].aggregation.price.max)
                    EditfilterForm.prices.min = parseInt(response.data.data[0].aggregation.price.min)

                    min = parseInt(response.data.data[0].aggregation.price.min)
                    max = parseInt(response.data.data[0].aggregation.price.max)

                    EditfilterForm.prices.value.push(min, max)
                    marks.push({ value: max, label: `$` + max })
                    marks.push({ value: min, label: `$` + min })
                    EditfilterForm.prices.elementConfig.options = marks
                    this.setState({
                        filterForm: EditfilterForm,
                        loading: false,
                        data: data
                    })
                } else {
                    this.setState({
                        // filterForm: EditfilterForm,
                        loading: false,
                        data: data
                    })
                }
            })
            .catch(error => {
                this.setState({
                    // filterForm: EditfilterForm,
                    loading: false
                })
            })
    }

    handleChange = (event, name, value) => {
        event.stopPropagation()
        event.preventDefault()
        const updatedfilterForm = {
            ...this.state.filterForm,
            [name]: {
                ...this.state.filterForm[name],
                value: event.target.value,
                touched: true
            }
        }
        this.handleFilter(updatedfilterForm, 'deliver')
        this.setState({ filterForm: updatedfilterForm })
    }

    handleSliderChange = (event, name, newValue) => {

        const EditfilterForm = { ...this.state.filterForm }
        EditfilterForm.prices.value = newValue
        this.setState({ filerForm: EditfilterForm })

    }

    handleFilter = (editForm, type) => {

        let filterId = []
        editForm.brand.elementConfig.options.map((d, i) => {
            if (d.value) {
                filterId.push({ filterId: d.retailer_public_id })
            }
        })

        const formData = new FormData()
        formData.append(`main_category_slug`, this.state.Maincategory)
        formData.append(`sub_category_slug`, this.state.SubCategory)
        formData.append('min_product_price', editForm.prices.value[0])
        formData.append('max_product_price', editForm.prices.value[1])

        if (type == 'deliver') {
            formData.append('product_delivery_period[0]', editForm.product_delivery_period.value)
        }
        if (filterId.length > 0) {
            filterId.map((d, i) => {
                formData.append(`retailer_public_id[${i}]`, d.filterId)
            })
        }
        this.getProductAPI(formData, 'filter')
    }

    handleReset = () => {

        const formData = new FormData()
        formData.append(`main_category_slug`, this.state.Maincategory)
        formData.append(`sub_category_slug`, this.state.SubCategory)
        const EditfilterForm = { ...this.state.filterForm }
        var min = parseInt(EditfilterForm.prices.max)
        var max = parseInt(EditfilterForm.prices.min)
        EditfilterForm.prices.value = []
        EditfilterForm.prices.value.push(min, max)
        EditfilterForm.product_delivery_period.value = ''

        this.setState({ filerForm: EditfilterForm })
        this.getProductAPI(formData, 'filter')

    }

    handleCheckBox = (event, name) => {

        event.preventDefault()
        const EditfilterForm = { ...this.state.filterForm }
        const selectedName = event.target.name

        EditfilterForm.brand.elementConfig.options.map((d, i) => {
            if (selectedName == d.name) {
                d.value = !d.value
            }
        })
        this.handleFilter(EditfilterForm)
        this.setState({
            filterForm: EditfilterForm
        })

    }


    render() {
        const {
            fixedLeft,
            valueTxt,
            filterForm,
            loading,
            data
        } = this.state

        const formElementsArray = []

        for (let key in filterForm) {
            formElementsArray.push({
                id: key,
                config: filterForm[key]
            })
        }
        return (
            <Fragment>
                <Row className="m-0 banner">
                    <Col md={12} className="p-0">
                        <Carousel>
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src="http://localhost:3000/images/banner1.jpg"
                                    alt="First slide"
                                />
                            </Carousel.Item>
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src="http://localhost:3000//images/banner2.jpg"
                                    alt="Third slide"
                                />
                            </Carousel.Item>
                        </Carousel>
                    </Col>
                </Row>
                <Container fluid >
                    <Row className="mt-4 p-2">
                        {!loading &&
                            <Col md={3} className="border-right">
                                <div className="sticky mt-4">
                                    <Row>
                                        <Col md={8}>
                                            <h4>Filter By</h4>
                                        </Col>
                                        <Col md={4}>
                                            {/* <p onClick={()=>this.handleReset()}>
                                        Reset
                                        </p> */}
                                            <Buttons
                                                buttonType="secondary"
                                                buttonAction={this.handleReset}
                                                buttontext="Reset"
                                                classInput="col-md-12  mt-2"
                                            />
                                        </Col>
                                    </Row>
                                    {
                                        formElementsArray.map((formElement, index) => (
                                            formElement.config.elementType == 'slider' ?
                                                <Row key={index} className="mt-4">
                                                    <Col sm={12}>
                                                        <Row>
                                                            <Col md={8}>
                                                                <p>Prices</p>
                                                            </Col>


                                                        </Row>

                                                        <hr />
                                                    </Col>
                                                    <Col sm={8}>
                                                        <FormsInput
                                                            label={formElement.config.label}
                                                            elementConfig={formElement.config.elementConfig}
                                                            elementType={formElement.config.elementType}
                                                            variant={formElement.config.variant}
                                                            value={formElement.config.value}
                                                            shouldValidiate={formElement.config.validation}
                                                            classname={formElement.config.classname}
                                                            touched={formElement.config.touched}
                                                            invalid={formElement.config.invalid}
                                                            min={formElement.config.min}
                                                            max={formElement.config.max}
                                                            changed={(event, value) => this.handleSliderChange(event, formElement.config.name, value)}

                                                        />
                                                    </Col>
                                                    <Col md={4}>
                                                        <Buttons
                                                            buttonType="primary"
                                                            buttonAction={(obj, type) => this.handleFilter(filterForm, 'filter')}
                                                            buttontext="Apply"
                                                            classInput="col-md-12"
                                                        />

                                                    </Col>
                                                </Row>
                                                :
                                                formElement.config.elementType == 'checkboxGroup' ?
                                                    <Row key={index} className="mt-4">
                                                        <Col sm={12}>
                                                            <FormsInput
                                                                label={formElement.config.label}
                                                                elementConfig={formElement.config.elementConfig}
                                                                elementType={formElement.config.elementType}
                                                                variant={formElement.config.variant}
                                                                value={formElement.config.value}
                                                                shouldValidiate={formElement.config.validation}
                                                                classname={formElement.config.classname}
                                                                touched={formElement.config.touched}
                                                                invalid={formElement.config.invalid}
                                                                changed={(event, value) => this.handleCheckBox(event, formElement.config.name)}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    :
                                                    <Row key={index} className="mt-4">
                                                        <Col sm={12}>
                                                            <p>Delivery Period</p>
                                                            <hr />
                                                            <FormsInput
                                                                label={formElement.config.label}
                                                                elementConfig={formElement.config.elementConfig}
                                                                elementType={formElement.config.elementType}
                                                                variant={formElement.config.variant}
                                                                value={formElement.config.value}
                                                                shouldValidiate={formElement.config.validation}
                                                                classname={formElement.config.classname}
                                                                touched={formElement.config.touched}
                                                                invalid={formElement.config.invalid}
                                                                changed={(event, value) => this.handleChange(event, formElement.config.name, value)}
                                                            />
                                                        </Col>
                                                    </Row>
                                        ))
                                    }
                                </div>
                            </Col>
                        }
                        <Col md={8}>
                            <Row>
                                {
                                    data.map((d, i) => (
                                        <Col md={4} key={i}>
                                            <ProductCard
                                                image={d.product_main_images}
                                                index={i}
                                                product_slug={d.product_slug}
                                                product_uuid={d.product_uuid}
                                                productName={d.product_name}
                                                dimension={d.product_dimension}
                                                attributes={d.attributes}
                                            />
                                        </Col>


                                    ))
                                }
                            </Row>
                        </Col>
                    </Row>
                </Container>

            </Fragment>
        )

    }
}

// const mapStateToProps = state => {
//     return {
//         products: state.products.productsData,
//         loading: state.products.loading,
//         // token: state.auth.token,
//         // userId: state.auth.userId
//     }
// }


// const mapDispatchToProps = dispatch => {
//     return {
//         // onCategoryRemove:(categoryID) => dispatch(actions.removeCategory(categoryID)),
//         onFetchProducts: (formData) => dispatch(actions.fetchProducts(formData))
//     }
// }
// export default connect(mapStateToProps,mapDispatchToProps)(Products)
export default Products